
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-44225e5d&scoped=true!stylus-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./column.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./column.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-44225e5d!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./column.vue"),
  /* scopeId */
  "data-v-44225e5d",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/column/column.vue
// module id = 202
// module chunks = 2